import { render, staticRenderFns } from "./DocumentsPane.vue?vue&type=template&id=7abcc7f3&scoped=true&"
import script from "./DocumentsPane.vue?vue&type=script&lang=js&"
export * from "./DocumentsPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abcc7f3",
  null
  
)

export default component.exports